import { Link } from 'react-router-dom';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';

const quickLinks = [
  { label: 'Home', href: '/', icon: 'ri-home-line' },
  { label: 'Programmes', href: '/programmes', icon: 'ri-book-2-line' },
  { label: 'Corporate Training', href: '/corporate-training', icon: 'ri-building-2-line' },
  { label: 'SETA Compliance', href: '/seta-compliance', icon: 'ri-shield-check-line' },
  { label: 'About Us', href: '/about', icon: 'ri-information-line' },
  { label: 'Contact', href: '/contact', icon: 'ri-phone-line' },
];

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center bg-[#F8FAF8] py-24 px-4">
        <div className="max-w-2xl w-full text-center">
          {/* Big 404 */}
          <div className="relative inline-block mb-6">
            <span className="text-[10rem] font-bold font-serif leading-none text-[#2D7F3E]/10 select-none">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 bg-[#2D7F3E]/10 rounded-2xl flex items-center justify-center">
                <i className="ri-map-pin-2-line text-4xl text-[#2D7F3E]"></i>
              </div>
            </div>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold font-serif text-[#1A1A1A] mb-4">
            Page Not Found
          </h1>
          <p className="text-gray-500 text-lg mb-10 leading-relaxed">
            The page you're looking for doesn't exist or may have moved. Let us point you in the right direction.
          </p>

          {/* Primary CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-[#2D7F3E] text-white font-semibold px-7 py-3.5 rounded-xl hover:bg-[#256632] transition-colors"
            >
              <i className="ri-home-line"></i>
              Back to Home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#2D7F3E] text-[#2D7F3E] font-semibold px-7 py-3.5 rounded-xl hover:bg-[#2D7F3E] hover:text-white transition-colors"
            >
              <i className="ri-customer-service-2-line"></i>
              Contact Support
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">
              Popular Pages
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="flex items-center gap-2.5 bg-white border border-gray-100 rounded-xl px-4 py-3 text-sm font-medium text-gray-700 hover:border-[#2D7F3E]/30 hover:text-[#2D7F3E] hover:bg-green-50 transition-all duration-200 group"
                >
                  <i className={`${link.icon} text-[#2D7F3E] text-base`}></i>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
